module.exports = __webpack_public_path__ + "static/media/linsheng.ef0efe11.jpg";